export const SUMMARY = '/summary'
export const SUMMARY_LIST = '/summary/list'
export const SUMMARY_SELECTION = '/summary/selection'
export const COLLECTIONS = '/collections'
